module.exports = __webpack_public_path__ + "media/images/training_case8-a33a839c4e160fd0dda546ee0be5d925.jpg";